import { Form, Modal } from "antd";
import React, { memo, useCallback } from "react";
import update from "immer";
import moment from "moment";

import BienKSXe from "../conponents/BienKSXe";
import ChiNhanhXe from "../conponents/ChiNhanhXe";
import SelectDate from "../conponents/SelectDate";

const TicketFeeReportModal = ({ onCancel, onOk, visible }) => {
  const [form] = Form.useForm();

  const handleClickOk = useCallback(() => {
    const query = update(form.getFieldsValue(), (draf) => {
      draf.branch_code = draf.branch_code === "all" ? null : draf.branch_code;

      draf.to = draf.to
        ? draf.to
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .format("x")
        : moment()
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .format("x");

      draf.from = draf.from
        ? draf.from
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .format("x")
        : 0;
    });

    if (!!onOk) {
      onOk(query);
      form.resetFields();
    }
  }, [onOk, form]);

  const handleCancel = useCallback(() => {
    !!onCancel && onCancel();
    form.resetFields();
  }, [onCancel, form]);

  return (
    <Modal
      onCancel={handleCancel}
      onOk={handleClickOk}
      width={700}
      title="Chọn tham số lọc báo cáo Chi phí vé"
      visible={visible}
      okText="Lọc báo cáo"
      cancelText="Huỷ"
    >
      <Form
        labelAlign="left"
        form={form}
        labelCol={{ span: 9 }}
        wrapperCol={{ span: 16 }}
        initialValues={{
          branch_code: "all",
          from: 0,
          to: 0,
          vehicle_number_plates: null,
        }}
      >
        <SelectDate type="TicketFee" setFieldsValue={form.setFieldsValue} />

        <Form.Item
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          label="Chi nhánh xe"
          name="branch_code"
        >
          <ChiNhanhXe
            type="TicketFee"
            name="branch_code"
            setFieldsValue={form.setFieldsValue}
            value={form.getFieldsValue("branch_code")}
          />
        </Form.Item>

        <Form.Item
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          label="Biển KS xe"
          name="vehicle_number_plates"
        >
          <BienKSXe
            type="TicketFee"
            name="vehicle_number_plates"
            setFieldsValue={form.setFieldsValue}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default memo(TicketFeeReportModal);
